﻿import React from 'react';
import { connect } from 'react-redux';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { toggleVilkar } from '../Store/Valg/Actions';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { VeilederFarBarnAppState } from '../Store';

type VilkarState = {
    open: boolean;
};

type VilkarProps = MapStateToProps &
    MapDispatchToProps & {
        lenketekst: any;
        tittel: any;
        innhold: any;
        lukk: any;
    };

class VilkarComponent extends React.PureComponent<VilkarProps, VilkarState> {
    constructor(props: VilkarProps) {
        super(props);
        this.onVilkarClick = this.onVilkarClick.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
        this.state = { open: false };
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleVilkar();
        this.setState({ open: false });
    }

    onVilkarClick(): void {
        this.props.updateZIndex(2);
        this.props.toggleVilkar();
        this.setState({ open: true });
    }

    render(): JSX.Element {
        if (this.props.lenketekst != null && this.props.lenketekst != undefined) {
            return (
                <div className="c-lamell__lenke">
                    <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onVilkarClick}>
                        {this.props.lenketekst}
                    </button>
                    <ModalCompontent
                        isOpen={this.state.open}
                        onRequestClose={this.onRequestClose}
                        ariaCloseText={this.props.lukk}
                    >
                        <ArticleContentComponent
                            headerinnhold={this.props.tittel}
                            contentinnhold={this.props.innhold}
                        />
                    </ModalCompontent>
                </div>
            );
        } else {
            return <div></div>;
        }
    }
}

interface MapStateToProps {
    locale: string;
}

interface MapDispatchToProps {
    toggleVilkar: typeof toggleVilkar;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederFarBarnAppState): MapStateToProps => {
        return {
            locale: state.epiContext.locale,
        };
    },
    { toggleVilkar, updateZIndex },
)(VilkarComponent);
